import { createContext } from "react"
import useSendMessage from "../hooks/send-message"

export const SendMessageContext = createContext()

export function SendMessageProvider({ children }) {
  const sendMessageContextValue = useSendMessage()

  return <SendMessageContext.Provider value={sendMessageContextValue}>{children}</SendMessageContext.Provider>
}
